import {
  IonButton,
  IonCol,
  IonGrid,
  IonModal,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useMemo, useState } from "react";
import { LoadStop } from "../loadStops/loadStops";
import { ShipmentDetails } from "../shipment-details/shipmentDetails";
import getTime from "../../../utils/getTimePeriod";
import "./ShipmentMap.scss";
import { PCMilerShipmentMap } from "../../../components/shared/PCMilerMap";

export type ShipmentMapProps = {
  shipments: any[];
  onCloseMapView: (shipent: any) => void;
  mapId?: string;
};

type ShipmentMapBaseProps = ShipmentMapProps & {
  onDismissDialog: () => void;
  onOpenDialog: () => void;
  isDialog?: boolean;
};

export type ShipmentWithCount = {
  shipment: any;
  loadStops: any[];
  totalShipments: number;
  locationName: string;
};

function getShipmentWithCount(shipments: any[]): ShipmentWithCount[] {
  let shipmentWithLocation: ShipmentWithCount[] = [];

  let locationName: string = "";

  shipments.forEach((shipment: any, index: number) => {
    let loadStops: any[] = (shipment && shipment.loadStop) || [];

    loadStops = loadStops.slice().sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    });

    if (loadStops.length > 0) {
      let city: string = loadStops[0].city;
      let state: string = loadStops[0].state;
      let country: string = loadStops[0].country;
      locationName = `${city ? city : ""}`;
      locationName = `${locationName ? `${locationName}, ` : ""}${state ? state : ""
        }`;
      locationName = `${locationName ? `${locationName}, ` : ""}${country ? country : ""
        }`;
    }
    if (locationName) {
      shipmentWithLocation.push({
        locationName: locationName.toUpperCase(),
        shipment: shipment,
        totalShipments: 1,
        loadStops: loadStops,
      });
    }
  });

  return shipmentWithLocation;
}

const ShipmentMapBase: React.FunctionComponent<ShipmentMapBaseProps> = (
  props: ShipmentMapBaseProps
) => {
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(false);
  const [shipmentsToShow, setShipmentToShow] = useState<ShipmentWithCount[]>(
    []
  );
  const _shipmentsWithCount: ShipmentWithCount[] = getShipmentWithCount(
    props.shipments
  );
  const calculateTime = (stop: any) => {
    return getTime(stop.appointmentFrom || "", stop.appointmentTo || "")
      .replace(/Z/g, "")
      .replace(/z/g, "");
  };

  const onClickLoadTile = (shipment: any) => {
    setIsDrawerVisible(false);
    props.onCloseMapView(shipment);
  };
  
  useEffect(() => {
    isDrawerVisible && setIsDrawerVisible(false);
  }, [JSON.stringify(props.shipments)]);

  useEffect(() => {
    isDrawerVisible && setIsDrawerVisible(false);
  }, [JSON.stringify(props.shipments)]);

  return (
    <div className="map-container">
      <div className="shipment-map">
        {
          useMemo(() => {
            return (
              <PCMilerShipmentMap
                shipments={_shipmentsWithCount}
                onShipmentsMarkerClick={(loads: any) => {
                  setIsDrawerVisible(true);
                  setShipmentToShow(loads);
                }}
                fitBoundsResize={isDrawerVisible}
                isDialog={props.isDialog}
                onExpand={props.onOpenDialog}
                onCollapse={props.onDismissDialog}
              />
            )
          }, [JSON.stringify(props.shipments), isDrawerVisible])
        }
      </div>
      <div style={{ display: isDrawerVisible ? "block" : "none" }}>
        {isDrawerVisible && (
          <React.Fragment>
            <IonButton
              className="dismiss"
              onClick={() => {
                setIsDrawerVisible(false);
              }}
            >
              &times;
            </IonButton>
            <div className="shipment-details-map" style={{ height: props.isDialog ? '100%' : '645px' }}>
              {shipmentsToShow.map((_shipment: ShipmentWithCount, index) => {
                const loadStopsToShow: any[] = [];

                _shipment.loadStops.forEach((load: any, index: number) => {
                  if (index == 0 || index == _shipment.loadStops.length - 1) {
                    loadStopsToShow.push(load);
                  }
                });

                return (
                  <div className="stop-grid-element" key={"shipmentToShow_" + index}>
                    <IonGrid
                      className="map-stop-details-grid"
                      onClick={() => {
                        onClickLoadTile(_shipment);
                      }}
                    >
                      <IonRow className="map-stop-details-row">
                        <IonCol size="5" className="map-stop-details-col">
                          <ShipmentDetails
                            {..._shipment.shipment}
                            isCarrierLoad={true}
                            showLoadNo={
                              !!_shipment.shipment.shipmentId ? false : true
                            }
                          />
                        </IonCol>
                        <IonCol size="7" className="map-stop-details-col">
                          <LoadStop
                            loadStops={loadStopsToShow}
                            calculateTime={calculateTime}
                            hideActivity={true}
                          />
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

const ShipmentMap: React.FunctionComponent<ShipmentMapProps> = (
  props: ShipmentMapProps
) => {
  const [open, toggleDialog] = useState<boolean>(false);
  const [showMap, setShowMap] = useState<boolean>(false)

  return (
    <>
      <IonModal backdropDismiss={false} cssClass="map-on-dlg" isOpen={open} onDidPresent={() => { setShowMap(true); }} onDidDismiss={() => { setShowMap(false); }} >
        {showMap && <ShipmentMapBase
          {...props}
          onDismissDialog={() => {
            toggleDialog(false);
          }}
          onOpenDialog={() => {
            toggleDialog(true);
          }}
          isDialog={open}
        />}
      </IonModal>
      <ShipmentMapBase
        {...props}
        onDismissDialog={() => {
          toggleDialog(false);
        }}
        onOpenDialog={() => {
          toggleDialog(true);
        }}
        isDialog={false}
      />
    </>
  );
};

export default ShipmentMap;
